/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopResourcesWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("TopResourcesWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TopResourcesWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TopResourcesWidgetConfiguration>): TopResourcesWidgetConfiguration {
        let obj = Object.assign(new TopResourcesWidgetConfiguration(), model);
        TopResourcesWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopResourcesWidgetConfiguration>): TopResourcesWidgetConfiguration {
        if (!model) return null;
        return TopResourcesWidgetConfiguration.newInstance(<TopResourcesWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopResourcesWidgetConfiguration) {
        if (!obj) return;

        models.TopResourcesWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopResourcesWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TopResourcesWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    forPlatform: boolean;

}
